module.exports = __webpack_public_path__ + "img/kv_fw2.126e7a68.png";